import { NgxLoggerLevel } from 'ngx-logger';

export const environment = {
  production: true,
  clientVersion: '1.81.0-106-g2ad36659',
  logLevel: NgxLoggerLevel.INFO,
  API_HOST: 'https://' + window.location.hostname
};
